import { render } from "./Copyright.vue?vue&type=template&id=c4f1e33c&scoped=true"
import script from "./Copyright.vue?vue&type=script&lang=js"
export * from "./Copyright.vue?vue&type=script&lang=js"

import "./Copyright.vue?vue&type=style&index=0&id=c4f1e33c&scoped=true&lang=stylus"

import exportComponent from "K:\\ダウンロード\\JASRAC対応\\新しいフォルダー\\東京書籍様_JASRACマーク実装_納品データ\\東京書籍様_JASRACマーク実装_納品データ-最終作業用\\e_5\\e_5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4f1e33c"]])

export default __exports__